import BannerTemplate from '../../../component/template/BannerTemplate.js'
import App from "../../../App"
import {onNativeHideCloseButton, onNativeShowCloseButton} from "../../../../api/nativeCalledListener";
import {getPageUrlParams} from '../../../../common/util'
import {reportNonBizData} from "../../../../common/m_common/mNonBizReport";
import BannerMoreOfferManager from "../../../bussinessComponent/BannerMoreOfferManager";
import i18nTools from "../../../../common/locale/format";
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import SwiperCore, {Pagination} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Pagination]);

export default class DefaultBanner extends BannerTemplate {
    constructor(props) {
        super(props)
        this.campaign = props.campaign || {}
        this.closeBtnSetAble = true;
        this.mof = getPageUrlParams('mof'); // =1 开启猜你喜欢
        this.atftm = getPageUrlParams('atftm'); // 刷新时间，单位 s ，若开发者配置刷新时间<x秒，不执行mof业务，若>=x秒或者未设置自动刷新逻辑则会执行mof业务，目前h5无法获取刷新时间，统一按展示猜你喜欢
        this.atltm = getPageUrlParams('atltm'); // 请求时间，单位 s ，banner模板展示广告后（上报展示后），启动计时逻辑，检测到banner广告展示y秒后，触发more offer请求（more offer请求参数不变，相关参数均从sdk获取）
        this.moftype = getPageUrlParams('moftype'); // more offer请求&展示模式，moftype=1表示一次请求10条广告，按“猜你喜欢”样式进行呈现，用户可横向滑动切换其他广告内容；moftype=2，一次仅获取一条广告，按banner basic 1114 模板样式进行呈现
        this.htrc = getPageUrlParams('htrc'); // =1 开启心跳统计上报，开启后在模板展示之后模板本身每隔1秒上报心跳埋点，用于统计展示周期
        this.hideMtgLogo(); // 服务端参数控制隐藏mtg logo
        window.reportNonBizData = reportNonBizData;
    }

    adShowed(res) {
        super.adShowed(res)
        // webview展示后开始上报心跳埋点
        this.reportHeartbeat();
        // 初始化 banner 猜你喜欢
        this.initMoreOffer();
        // let encodeVideo = window.base64.encodePrivate('https://assets.dspunion.com/cdn-adn/vh/19/02/21/11/21/948e27b8d8571d92db0459076774e49e.mp4')
        // let decodeVIdeo = window.base64.decodePrivate(encodeVideo)
        // console.log('base64编码解码：：：：：========》',encodeVideo,decodeVIdeo )
        // campaign.video_url = `mtg-h5://videoSource?uri=${encodeURIComponent(campaign.video_url)}`
    }

    // 初始化 more offer
    initMoreOffer() {
        if (this.mof == "1") {
            console.log("###准备初始化猜你喜欢")
            let atltm = 10 * 1000; // 兜底10秒
            if(this.atltm && this.atltm !== undefined && this.atltm !== ""){
                atltm = this.atltm * 1000;
            }
            // 如果参数atltm时间大于等于1500，则提前1500ms去请求猜你喜欢（避免渲染猜你喜欢空白问题），否则正常请求猜你喜欢
            if (atltm >= 1500) {
                atltm = atltm - 1500
            }
            let moftype = "1"; // 兜底为1
            if(this.moftype && this.moftype !== undefined && this.moftype !== ""){
                moftype = this.moftype;
            }
            setTimeout(() => {
                if (moftype == "1") {
                    this.moreOffer = new BannerMoreOfferManager({
                        APP: App,
                        campaign: this.campaign,
                        title: i18nTools.formatByUA('_recommend'),
                        maxLength: 10,
                        moftype: "1",
                        readyLength: 5,
                        onReady: [],
                        onScroll: [],
                        onError: [],
                        onLoadSuccess:[()=> {
                            // load成功之后，再调用show方法，确保不会同时上报loadFailed和loadTimeout
                            this.moreOffer.show(Date.now())
                            // 由于渲染猜你喜欢有一个时间过程，直接请求并展示轮播会导致大约1秒的轮播白屏，需提前至少1.5秒请求
                            setTimeout(() => {
                                this.initMoreOfferSwiper()
                            }, 1500)
                        }],
                        onOfferClick: [({event, campaign}) => {
                            this.platform.clickInstall(event, {campaign, template: "banner"})
                        }],
                    })
                } else if (moftype == "2") {
                    this.moreOffer = new BannerMoreOfferManager({
                        APP: App,
                        campaign: this.campaign,
                        maxLength: 1,
                        minLength: 1,
                        moftype: "2",
                        readyLength: 1,
                        onReady: [],
                        onScroll: [],
                        onError: [],
                        onLoadSuccess:[()=> {
                            // load成功之后，再调用show方法，确保不会同时上报loadFailed和loadTimeout
                            this.moreOffer.show(Date.now())
                            // 由于渲染猜你喜欢有一个时间过程，直接请求并展示轮播会导致大约1秒的轮播白屏，需提前至少1.5秒请求
                            setTimeout(() => {
                                this.initMoreOfferSwiper()
                            }, 1500)
                        }],
                        onOfferClick: [({event, campaign}) => {
                            this.platform.clickInstall(event, {campaign, template: "banner"})
                        }],
                    })
                }
            }, atltm)
        }
    }

    // 初始化 more offer 轮播
    initMoreOfferSwiper() {
        const swiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            loop: false, // 默认循环模式为false，为避免循环模式后动态复制的猜你喜欢和offer本身绑定的点击事件不生效，不开启循环模式
            pagination: {
                el: '.swiper-pagination',
            },
            paginationType: 'fraction',
            initialSlide: 1,// 默认从swiper2开始展示，即 moreoffer请求到后优先展示moreoffer
        });
    }

    reportHeartbeat() {
        // 判断 htrc 参数，等于1，上报心跳埋点
        if (this.htrc == "1") {
            // 如果定时器存在，先清除定时器
            if (htInterval) {
                clearInterval(htInterval)
            }
            // 初始化当前展示的秒数
            let second = 0
            // 设置定时器，每隔1秒上报一个心跳埋点：mtg_mof_heartbeat，附带当前秒数参数
            var htInterval = setInterval(() => {
                second++;
                reportNonBizData({reportType: "mtg_banner_heartbeat", reportApiClass: 'BannerJSPlugin', dataCustomized: {"second": second}})
            }, 1000)
        }
    }

    /**
     * 注册sdk调用设置关闭按钮方法
     */
    registerNativeSetCloseButton() {
        onNativeShowCloseButton((params = {}, resolve, reject) => {
            this.closeBtnSetAble = false
            this.showCloseBtn && this.showCloseBtn().then(() => {
                resolve()
            }).catch(() => reject())
        })
        onNativeHideCloseButton((params = {}, resolve, reject) => {
            this.closeBtnSetAble = false
            this.hideCloseBtn && this.hideCloseBtn().then(() => {
                resolve()
            }).catch(() => reject())
        })
    }

    /**
     * 初始化banner关闭按钮
     * @param bridgeContext v3返回的数据
     * @param bridgeContext.sdkSetting.dev_close_state ，1表示开发者设置为展示，2表示开发者设置为关闭，0表示开发者未设置
     */
    initBannerCloseBtn() {
        // 如果开发者没有设置过closeButton的显示状态，则默认按setting展示
        console.log('this.closeBtnSetAble ===> ', this.closeBtnSetAble)
        if (!this.closeBtnSetAble) {
            return
        }
        console.log("初始化banner关闭按钮")
        console.log('App.initData =======>', App.initData)
        let sdkSettingState = Number(App.initData.sdkSetting.dev_close_state);
        let unitSettingState = Number(App.initData.unitSetting.closeBtn);
        console.log("sdkSettingState", sdkSettingState)
        console.log("unitSettingState", unitSettingState)
        if (sdkSettingState === 1) {
            this.showCloseBtn()
        } else if (sdkSettingState === 2) {
            this.hideCloseBtn()
        } else if (unitSettingState === 1) {
            this.showCloseBtn()
        } else {
            this.hideCloseBtn()
        }
    }

    /**
     * 根据服务端参数控制，隐藏mtg品牌logo，n_logo=0 隐藏，不传或为空或其他都为展示
     */
    hideMtgLogo() {
        let n_logo = getPageUrlParams('n_logo');
        if (parseInt(n_logo) === 0) {
            if (document.getElementsByClassName("mtg")) {
                for (let item of Array.from(document.getElementsByClassName("mtg"))) {
                    item.setAttribute("style", "display:none");
                }
            }
            if (document.getElementsByClassName("info-logo")) {
                for (let item of Array.from(document.getElementsByClassName("info-logo"))) {
                    item.setAttribute("style", "display:none");
                }
            }
        }
    }
}